<template>
	<div class="container">
		<div class="privacy">
			<div class="policy">
				<div class="policy-title">公司荣誉 Company honor</div>
				<div class="policy-content">
					<div class="policy-c-view">
						
						<p>2018年至今，播聘在社会责任以及创新发展上赢得多项殊荣</p>
						<ul>
							<li>持续帮助超过3000名心智障碍和唐氏综合征特殊群体实现正常就业</li>
							<li>被评为深圳市互联网创新企业</li>
							<li>被评为深圳企业社会责任三星企业</li>
							<li>被评为深圳市最具创新商业模式奖</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:`CompanyHonor`
	}
</script>

<style scoped="scoped">
	@import url("./company-honor");
</style>



// WEBPACK FOOTER //
// src/pages/company-honor/company-honor.vue